<template>
  <span>
    <v-dialog max-width="500px" persistent v-model="dialog">
      <template #activator="{on}">
        <span v-on="on">
          <slot>
            <v-tooltip bottom>
              {{ $t("global.edit") }}
              <template #activator="{on: tooltip}">
                <v-btn icon v-on="tooltip">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </slot>
        </span>
      </template>

      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("settings.userSubstitute.dialogTitle") }}</span>
        </v-card-title>
        <v-card-text>
          <v-form lazy-validation ref="form" v-model="formValid">
            <v-autocomplete
              :items="computedAvailableUsers"
              :label="$t('settings.userSubstitute.fields.absentUser.name') + '*'"
              v-model="contextUserSubstitute.absent_user_id"
              :rules="validators.absent_user_id"
            >
            </v-autocomplete>

            <v-autocomplete
              :items="computedAvailableUsers"
              :label="$t('settings.userSubstitute.fields.substituteUser.name') + '*'"
              v-model="contextUserSubstitute.substitute_user_id"
              :rules="validators.substitute_user_id"
            >
            </v-autocomplete>

            <date-time-picker-computed
              :date-time-model.sync="contextUserSubstitute.from_date"
              :label="$t('settings.userSubstitute.fields.fromDate.name')"
              :placeholder="$t('settings.userSubstitute.fields.fromDate.placeholder')"
            ></date-time-picker-computed>

            <date-time-picker-computed
              :date-time-model.sync="contextUserSubstitute.to_date"
              :label="$t('settings.userSubstitute.fields.toDate.name')"
              :placeholder="$t('settings.userSubstitute.fields.toDate.placeholder')"
            ></date-time-picker-computed>

            <v-text-field :label="$t('settings.userSubstitute.fields.comment.name')" v-model="contextUserSubstitute.comment"></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="dialog = false" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="!formValid || $store.getters['Ajax/loading']" @click="save" color="blue darken-1" text>{{ $t("global.save") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import DateTimePickerComputed from "../CustomInputComponents/DateTimePickerComputed.vue";

export default {
  name: "UserSubstituteForm",
  components: { DateTimePickerComputed },
  props: {
    userSubstitute: {
      required: false,
      default: () => ({
        id: null,
        substitute_user_id: null,
        absent_user_id: null,
        from_date: null,
        to_date: null,
        comment: null
      })
    }
  },
  data: () => {
    return {
      contextUserSubstitute: null,
      dialog: false,
      formValid: true,
      availableUsers: []
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.axios.get("settings/user-substitute/available-users").then(resp => {
          this.availableUsers = resp.data;
        });
      }
    }
  },
  computed: {
    validators() {
      return {
        absent_user_id: [(this.contextUserSubstitute != null && this.contextUserSubstitute.absent_user_id != null) || this.$t("global.error.required")],
        substitute_user_id: [(this.contextUserSubstitute != null && this.contextUserSubstitute.substitute_user_id != null) || this.$t("global.error.required")],
        from_date: [
          //v => (v != null && v.length > 0) || 'Nazwa jest wymagana' //TODO WALIDATOR data nie moze byc pozniejsza niz data koncowa
        ],
        to_date: [
          //v => (v != null && v.length > 0) || 'Nazwa jest wymagana' //todo walidator data nie moze byc wcześniejsza niż data początkowa
        ]
      };
    },
    computedAvailableUsers() {
      let result = [];
      for (let user of this.availableUsers) {
        result.push({ value: user.id, text: user.name + " " + user.surname });
      }
      return result;
    }
  },
  beforeMount() {
    this.contextUserSubstitute = this.userSubstitute;
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.axios
          .post("settings/user-substitute/item-save", this.contextUserSubstitute)
          .then(() => {
            if (this.userSubstitute.id == null) {
              this.contextUserSubstitute.substitute_user_id = null;
              this.contextUserSubstitute.absent_user_id = null;
              this.contextUserSubstitute.from_date = null;
              this.contextUserSubstitute.to_date = null;
              this.contextUserSubstitute.comment = null;
            }
            this.$store.dispatch("AUTH_UPDATE_SETTINGS").then(() => {
              this.$store.dispatch("snackbarPush", {
                text: this.$t("global.saved")
              });
              this.$emit("saved");
              this.dialog = false;
            });
          })
          .catch(resp => {
            console.log(resp.response);
          });
      }
    }
  }
};
</script>

<style scoped></style>
